module.exports = __webpack_public_path__ + "media/07.4eb67bfc.mp3";